import { gql } from "@apollo/client";

export const GET_ALL_OFFERS_WITH_QUERY = gql`
  query GetOffers(
    $qapiToken: String!
    $countryCode: Country!
    $languageCode: Language!
    $offset: Int!
    $query: String
  ) {
    search(
      qapiToken: $qapiToken
      countryCode: $countryCode
      languageCode: $languageCode
      filters: { query: $query }
      order: SCORE_DESC
      pagination: { offset: $offset, limit: 99999 }
    ) {
      offers {
        id
        name
        countries {
          sourceName
        }
        cities {
          sourceName
        }
        regions {
          sourceName
        }
        termsCount
      }
      count
      totalTripCount
    }
  }
`;
